import { useEffect } from 'react';
import dataRefreshService from '../services/dataRefreshService';

/**
 * 🚀 Hook d'initialisation du rafraîchissement automatique
 * À utiliser dans App.js ou dans le composant principal
 */

export const useAppDataInit = (options = {}) => {
  const {
    autoStart = true,
    refreshInterval = 30, // minutes
    initialRefresh = true
  } = options;

  useEffect(() => {
    if (autoStart) {
      console.log('🚀 Initialisation du système de rafraîchissement automatique...');
      
      // Démarrer le rafraîchissement automatique
      if (refreshInterval > 0) {
        dataRefreshService.startAutoRefresh(refreshInterval);
      }
      
      // Rafraîchissement initial si les données ne sont pas fraîches
      // (startAutoRefresh en déclenche déjà un immédiatement)
      if (initialRefresh && refreshInterval <= 0 && !dataRefreshService.isDataFresh()) {
        console.log('📊 Données obsolètes détectées, rafraîchissement initial...');
        dataRefreshService.refreshAllData().then((result) => {
          if (result.success) {
            console.log('✅ Rafraîchissement initial terminé avec succès');
          } else {
            console.log('⚠️ Rafraîchissement initial avec fallback sur données statiques');
          }
        });
      }
    }

    // Cleanup lors du démontage
    return () => {
      if (autoStart && refreshInterval > 0) {
        dataRefreshService.stopAutoRefresh();
      }
    };
  }, [autoStart, refreshInterval, initialRefresh]);

  return {
    refresh: () => dataRefreshService.forceRefresh(),
    getCurrentStats: () => dataRefreshService.getCurrentStats(),
    isDataFresh: () => dataRefreshService.isDataFresh()
  };
};

export default useAppDataInit;